// extracted by mini-css-extract-plugin
module.exports = {"nutrition-plan":"styles_nutrition-plan__3bHIj","nutrition-plan__header":"styles_nutrition-plan__header__dGe5s","nutrition-plan__body":"styles_nutrition-plan__body__1RWme"};